import { useCallback, useEffect, useState } from "react";
//#region src/hooks/useTimer.ts
const TIMER_TICK = 1e3;
const TIMER_DECREMENT = 1e3;
const useTimer = (countdownConsumer, tick = TIMER_TICK, decrement = TIMER_DECREMENT) => {
	const [countdown, setCountdown] = useState(countdownConsumer);
	const reset = useCallback(() => setCountdown(countdownConsumer), [countdownConsumer]);
	useEffect(() => {
		const interval = setInterval(() => {
			setCountdown((c) => Math.max(c - decrement, 0));
		}, tick);
		if (countdown === 0) clearInterval(interval);
		return () => clearInterval(interval);
	}, [
		countdown,
		decrement,
		tick
	]);
	return {
		countdown,
		reset
	};
};
//#endregion
export { useTimer };
